import { render, staticRenderFns } from "./SynchronizedScroll.vue?vue&type=template&id=57f16e23&"
import script from "./SynchronizedScroll.vue?vue&type=script&lang=js&"
export * from "./SynchronizedScroll.vue?vue&type=script&lang=js&"
import style0 from "./SynchronizedScroll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports